<template>
  <div class="search-results">
    <small-text class="search-results__count">{{ count }} Results</small-text>
    <scroll-panel>
      <div class="search-results__list">
        <div class="search-results__result-set" v-for="results in searchResultsFormatted">
          <list :key="results.name"
              :list-group="results" :scrollable="false"
              @item-selected="itemSelectedHandler">
          </list>
          <small-text class="search-results__no-results" :light="true" v-if="hasNoResults(results)">No Results</small-text>
        </div>
      </div>
    </scroll-panel>
  </div>
</template>

<script>
  import List from './List.vue'
  import SmallText from './SmallText.vue'
  import ScrollPanel from '@/components/common/scrollPanel'

  export default {
    components: {
      ScrollPanel,
      List,
      SmallText
    },
    props: [
      'results',
      'count'
    ],
    computed: {
      /**
       * We need to format the results in Tree data structure for list component
       */
      searchResultsFormatted () {
        return this.results.map(results => {
          return {
            model: {
              name: results.name
            },
            children: results.results.map(result => {
              return {
                model: result,
                hasChildren: () => false
              }
            })
          }
        })
      }
    },
    methods: {
      hasNoResults (results) {
        return results.children.length === 0
      },
      itemSelectedHandler (item) {
        this.$emit('item-selected', item)
      }
    }
  }
</script>

<style lang="scss">
  .search-results {
    display: flex;
    flex-direction: column;
    height: 100%;

    &__count,
    &__no-results {
      font-size: rem(13);
      font-style: italic;
    }

    &__count {
      align-self: flex-end;
      margin-right: rem(20);
      margin-bottom: rem(10);
      color: color(grays, extra-light);
    }

    &__no-results {
      color: #ffffff;
    }

    &__result-set {
      margin-bottom: rem(25);
    }

    &__list {
      position: relative;
    }
  }
</style>



// WEBPACK FOOTER //
// SearchResults.vue?b552ab1c